module.exports = __webpack_public_path__ + "img/extended.339931bc.png";